import React, { ComponentProps, useMemo } from "react";
import { useAsync } from "react-async";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import { configuration } from "./services/configuration/ConfigurationService";

export function AppMsalProvider({ children }: { children: React.ReactNode }) {
  const { data: configurationContent } = useAsync(configuration.get);

  const authClientApp = useMemo(
    () =>
      configurationContent
        ? new PublicClientApplication({
            auth: {
              clientId: configurationContent.clientId,
              authority: `${configurationContent.authority}/${configurationContent.sign_up_and_in_user_flow}`,
              redirectUri: configurationContent.redirect_uri,
              postLogoutRedirectUri: configurationContent.redirect_uri,
              knownAuthorities: configurationContent.knownAuthorities,
            },
            cache: {
              cacheLocation: "sessionStorage",
            },
            system: {
              navigateFrameWait: 0,
            },
          })
        : undefined,
    [configurationContent]
  );

  if (authClientApp) {
    return <MsalProvider instance={authClientApp}>{children}</MsalProvider>;
  } else {
    return <></>;
  }
}

export default function useMsalProvider() {}
useMsalProvider.Provider = AppMsalProvider;
useMsalProvider.FakeProvider = () => (props: ComponentProps<any>) => <>{props.children}</>;
